"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.jane.description': 'Donna giovane, calorosa, dolce e amichevole.',
};
